export const PauseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.97918 14.6664C11.6611 14.6664 14.6459 11.6816 14.6459 7.99968C14.6459 4.31778 11.6611 1.33301 7.97918 1.33301C4.29727 1.33301 1.3125 4.31778 1.3125 7.99968C1.3125 11.6816 4.29727 14.6664 7.97918 14.6664Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14537 9.68622V6.31288C7.14537 5.99288 7.01203 5.86621 6.67203 5.86621H5.80537C5.46536 5.86621 5.33203 5.99288 5.33203 6.31288V9.68622C5.33203 10.0062 5.46536 10.1329 5.80537 10.1329H6.66537C7.01203 10.1329 7.14537 10.0062 7.14537 9.68622Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 9.68622V6.31288C10.666 5.99288 10.5327 5.86621 10.1927 5.86621H9.33271C8.99271 5.86621 8.85938 5.99288 8.85938 6.31288V9.68622C8.85938 10.0062 8.99271 10.1329 9.33271 10.1329H10.1927C10.5327 10.1329 10.666 10.0062 10.666 9.68622Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
